module.exports = __webpack_public_path__ + "media/images/web_suite/icon_ebooks-3cf38ff62b26d63160417c5aaa7be84c.png";